// Coordinates for the main real estate city of each US state
export const US_STATES_COORDS = {
  AL: { lat: 33.518589, lng: -86.810356, city: "Birmingham" },
  AK: { lat: 61.217381, lng: -149.863129, city: "Anchorage" },
  AZ: { lat: 33.448376, lng: -112.074036, city: "Phoenix" },
  AR: { lat: 36.186745, lng: -94.128814, city: "Fayetteville" },
  CA: { lat: 37.774929, lng: -122.419418, city: "San Francisco" },
  CO: { lat: 39.739227, lng: -104.984856, city: "Denver" },
  CT: { lat: 41.308273, lng: -72.927887, city: "New Haven" },
  DE: { lat: 39.739227, lng: -75.539787, city: "Wilmington" },
  FL: { lat: 25.761681, lng: -80.191788, city: "Miami" },
  GA: { lat: 33.749001, lng: -84.387978, city: "Atlanta" },
  HI: { lat: 21.306944, lng: -157.858337, city: "Honolulu" },
  ID: { lat: 43.615021, lng: -116.202316, city: "Boise" },
  IL: { lat: 41.878113, lng: -87.629799, city: "Chicago" },
  IN: { lat: 39.768402, lng: -86.158066, city: "Indianapolis" },
  IA: { lat: 41.586834, lng: -93.625, city: "Des Moines" },
  KS: { lat: 39.114052, lng: -94.627464, city: "Kansas City" },
  KY: { lat: 38.252666, lng: -85.758453, city: "Louisville" },
  LA: { lat: 29.951065, lng: -90.071533, city: "New Orleans" },
  ME: { lat: 43.6591, lng: -70.25682, city: "Portland" },
  MD: { lat: 39.290386, lng: -76.61219, city: "Baltimore" },
  MA: { lat: 42.360081, lng: -71.058884, city: "Boston" },
  MI: { lat: 42.331429, lng: -83.045753, city: "Detroit" },
  MN: { lat: 44.977753, lng: -93.265015, city: "Minneapolis" },
  MS: { lat: 32.298756, lng: -90.184807, city: "Jackson" },
  MO: { lat: 38.627003, lng: -90.199402, city: "St. Louis" },
  MT: { lat: 46.58976, lng: -112.039146, city: "Helena" },
  NE: { lat: 41.256538, lng: -95.934502, city: "Omaha" },
  NV: { lat: 36.169941, lng: -115.139832, city: "Las Vegas" },
  NH: { lat: 42.99564, lng: -71.454788, city: "Manchester" },
  NJ: { lat: 40.735657, lng: -74.172363, city: "Newark" },
  NM: { lat: 35.084385, lng: -106.650421, city: "Albuquerque" },
  NY: { lat: 40.712776, lng: -74.005974, city: "New York" },
  NC: { lat: 35.227085, lng: -80.843124, city: "Charlotte" },
  ND: { lat: 46.877186, lng: -96.789803, city: "Fargo" },
  OH: { lat: 39.961346, lng: -82.999069, city: "Columbus" },
  OK: { lat: 35.46756, lng: -97.516426, city: "Oklahoma City" },
  OR: { lat: 45.51223, lng: -122.658722, city: "Portland" },
  PA: { lat: 39.952583, lng: -75.165222, city: "Philadelphia" },
  RI: { lat: 41.82399, lng: -71.412834, city: "Providence" },
  SC: { lat: 32.776474, lng: -79.931053, city: "Charleston" },
  SD: { lat: 44.080543, lng: -103.231018, city: "Rapid City" },
  TN: { lat: 36.162663, lng: -86.781601, city: "Nashville" },
  TX: { lat: 32.776665, lng: -96.796989, city: "Dallas" },
  UT: { lat: 40.76078, lng: -111.891045, city: "Salt Lake City" },
  VT: { lat: 44.475883, lng: -73.212074, city: "Burlington" },
  VA: { lat: 36.852924, lng: -75.977982, city: "Virginia Beach" },
  WA: { lat: 47.606209, lng: -122.332069, city: "Seattle" },
  WV: { lat: 39.629528, lng: -79.955887, city: "Morgantown" },
  WI: { lat: 43.038902, lng: -87.906471, city: "Milwaukee" },
  WY: { lat: 41.139981, lng: -104.820246, city: "Cheyenne" },
};
